@if (alertInfo.show) {
  <ngb-alert
    [type]="alertInfo.type"
    (closed)="alertInfo.show = false"
    >
    {{ alertInfo.message }}
  </ngb-alert>
}
<form [formGroup]="form">
  <div class="row g-3">
    <div class="col-sm-6 mt-2">
      <input-field
        type="text"
        [inputFormControl]="getSpecialisationCodeInput()"
        label="Code"
        placeholder="Code"
        />
    </div>
    <div class="col-sm-6 mt-2">
      <input-field
        type="text"
        [inputFormControl]="getSpecialisationNameInput()"
        label="Name"
        placeholder="Name"
        />
    </div>
  </div>

  <div class="text-center mt-4">
    <button
      type="button"
      class="btn btn-primary me-4 px-4 py-2"
      (click)="goBack()"
      >
      Back
    </button>
    <button
      type="button"
      class="btn btn-success px-4 py-2"
      (click)="submitForm()"
      >
      Save
    </button>
  </div>
</form>
